// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarketTypeFromJSON, MarketTypeToJSON, } from './';
export function MarketAllocationFromJSON(json) {
    return {
        'allocatedMarketCompositionId': !exists(json, 'allocatedMarketCompositionId') ? undefined : json['allocatedMarketCompositionId'],
        'allocatedMarketType': !exists(json, 'allocatedMarketType') ? undefined : MarketTypeFromJSON(json['allocatedMarketType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'percentWeight': !exists(json, 'percentWeight') ? undefined : json['percentWeight'],
    };
}
export function MarketAllocationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'allocatedMarketCompositionId': value.allocatedMarketCompositionId,
        'allocatedMarketType': MarketTypeToJSON(value.allocatedMarketType),
        'description': value.description,
        'number': value.number,
        'percentWeight': value.percentWeight,
    };
}
